"use strict";

import { Gamecloud } from '../../gamecloud';
import { createModUIInstances, ModUI } from './modUI';
import Axios from 'axios';
import { Notification } from '../../../notification/notfication';
import {Direction, IModData} from './interface';
import * as tinysort from 'tinysort';
import {initCheckbox} from "../../../components/checkbox/checkbox";

class Mod extends Gamecloud {

  public modId: string;

  public constructor(public ui: ModUI, private activeMods?: any[], public orderPosition?: number) {
    super();
    this.setModId();
    this.setEvents();
    if (this.activeMods) {
      this.ui.activateCheckboxForActiveMods(this.activeMods);
    }
    this.ui.renderReorder();
  }

  public setEvents() {
    this.ui.setCallbackonInstallButtonClick(this.installMod.bind(this));
    this.ui.setCallbackonUninstallButtonClick(this.uninstallMod.bind(this));
    this.ui.setCallbackOnCheckboxToggle(this.activateMod.bind(this), this.deactivateMod.bind(this));
    this.ui.onMoveDownClick(this.moveDown.bind(this));
    this.ui.onMoveUpClick(this.moveUp.bind(this));
  }

  static getActivatedModsFormData() {
    let form = new FormData();
    $('[data-mods-installed]').find('.mod input:checked').each(function (index) {
      let data: IModData = $(this).parents('.mod').data('mod');
      form.append('mods[]', data.modid);
    });

    return form;
  }

  static activateAll() {
    Axios.post(window.activateAllModUrl, Mod.getActivatedModsFormData(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      new Notification('success', 'Your mod is now active', response.data.message);
      window.setTimeout(() => {
        window.location.reload();
      }, 1000);
    }).catch((response) => {
      new Notification('danger', 'Ooops!', 'Something went wrong.');
    });
  }

  static deactivateAll() {
    Axios.get(window.deactivateAllModUrl, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      new Notification('success', 'Your mod is now active', response.data.message);
      window.setTimeout(() => {
        window.location.reload();
      }, 1000);
    }).catch((response) => {
      new Notification('danger', 'Ooops!', 'Something went wrong.');
    });
  }

  private moveUp() {
    window.dispatchEvent(new CustomEvent('orderMods', {
      detail: {
        direction: Direction.Up,
        modid: this.ui.getData().modid,
        mod: this,
      }
    }));
  }

  private moveDown() {
    window.dispatchEvent(new CustomEvent('orderMods', {
      detail: {
        direction: Direction.Down,
        modid: this.ui.getData().modid,
        mod: this
      }
    }));
  }

  /**
   * Install a Mod
   */
  private installMod() {
    this.loader.enable();
    this.ui.disableInstallButton();
    let url: any = window.installModUrl + '/' + this.modId;

    if (this.ui.isArma()) {
      //arma special case
      this.activateMod();
    } else {
      Axios.get(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        this.loader.disable();
        this.ui.enableInstallButton();
        if (!this.ui.isArma()) {
          //if not arma
          this.ui.moveToInstalled(this.afterMove.bind(this));
        }
        this.ui.installed = true;
        new Notification('success', 'Well done', response.data.message);
        //refresh the page if arma
        if (this.ui.isArma()) {
          window.setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }).catch((response) => {
        if (response) {
          this.loader.disable();
          this.ui.enableInstallButton();
          this.ui.installed = false;
          let message = 'Something went wrong';
          if (typeof response.data !== 'undefined' && response.data.message) {
            message = response.data.message;
          }
          new Notification('danger', 'Ooops!', message);
        }
      });
    }
  }

  /**
   * Uninstall a Mod
   */
  private uninstallMod() {

    if (this.ui.isArma()) {
      this.deactivateMod();
    } else {
      let url: any = window.uninstallModUrl + '/' + this.modId;

      this.loader.enable();
      this.ui.disableUninstallButton();

      Axios.get(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        this.loader.disable();
        this.ui.enableUninstallButton();

        //if not arma
        if (!this.ui.isArma()) {
          this.ui.moveToAvailable();
        }
        this.ui.installed = false;
        new Notification('success', 'Success', response.data.message);

        //refresh the page if arma
        if (this.ui.isArma()) {
          window.setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      }).catch((response) => {
        this.ui.enableUninstallButton();
        let message = 'Something went wrong';
        if (typeof response.data !== 'undefined' && response.data.message) {
          message = response.data.message;
        }
        new Notification('danger', 'Oops!', message);
      });
    }
  }

  /**
   * Activate mod
   */
  private activateMod() {
    this.loader.enable();
    let req = null;
    if (this.ui.isArma()) {
      let url = window.activateModUrl + '/' + this.ui.getData().modid + '/' + this.ui.getModTypeValue();
      req = Axios.get(url, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    } else {
      let url: string = window.activateModUrl + '/' + this.ui.getData().modid;
      req = Axios.post(url,  Mod.getActivatedModsFormData(),{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }

    req.then((response) => {
      this.loader.disable();
      new Notification('success', 'Your mod is now active', response.data.message);
      window.setTimeout(() => {
        window.location.reload();
      }, 1000);
    }).catch((error) => {
      this.loader.disable();
      this.ui.enableInstallButton();
      let msg = 'Something went wrong.';
      if (typeof error.response.data !== 'undefined' && error.response.data.message) {
        msg = error.response.data.message;
      }
      new Notification('danger', 'Ooops!', msg);
    });
  }

  /**
   * Deactivate mod
   */
  private deactivateMod() {
    this.loader.enable();
    let url = window.deactivateModUrl + '/' + this.ui.getData().modid;

    Axios.get(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      let message = 'Please restart your server to see the changes';
      if (response.data.message !== undefined) {
        message = response.data.message;
      }
      new Notification('success', 'Success', message);
      this.ui.enableUninstallButton();
      this.loader.disable();
      window.setTimeout(() => {
        window.location.reload();
      });
    }).catch((response) => {
      let message = 'Something went wrong.';
      if (response.data.message !== undefined) {
        message = response.data.message;
      }
      this.loader.disable();
      new Notification('danger', 'Ooops!', message);
    });
  }

  public afterMove() {
    initCheckbox(true);
    this.setEvents();

    // Workarround to set the right order position
    // @TODO: find better solution
    const lengthInstalledMods: number = this.ui.countInstalledMods();
    const differenzToNewPositon: number = this.ui.orderPosition - (lengthInstalledMods - 1);

    for (let index = differenzToNewPositon; index > 0; index--) {
      this.moveUp();
    }
  }

  /**
   * Set the mod id to a private var
   */
  private setModId(): void {
    const data = this.ui.getData();
    this.modId = data.modid;
  }
}

class ModReorder extends Gamecloud {
  public mods: Mod[] = [];

  public constructor(public initialOrderdItems: string[]) {
    super();
    window.addEventListener('orderMods', (event: CustomEvent) => {
      const currentIndex = this.getCurrentOrderIndex(event.detail.mod);
      let newIndex = Number(currentIndex) - Number(1);
      if (event.detail.direction == Direction.Down) {
        newIndex = Number(currentIndex) + Number(1);
      }
      this.mods = this.move(this.mods, currentIndex, newIndex);
      this.render();
      this.postReorder();
    });
  }

  public initialReorder() {
    const initialMods = [];
    this.initialOrderdItems.map((modid: string) => {
      this.mods.map((mod: Mod) => {
        if (modid === mod.ui.getData().modid) {
          initialMods.push(mod);
        }
      });
    });

    // remove initial orderd mods from modlist
    this.mods = this.mods.filter((mod) => this.initialOrderdItems.indexOf(mod.ui.getData().modid) < 0);
    initialMods.reverse().map((mod: Mod) => {
      this.mods.unshift(mod);
    });

    this.render();
  }

  private getCurrentOrderIndex(mod: Mod): number {
    return this.mods.indexOf(mod);
  }

  private move(arr, old_index, new_index) {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  }

  async updateOrderAttr() {
    return new Promise<void>(resolve => {
      this.mods.forEach((modInstance: Mod, index) => {
        modInstance.ui.$base.attr('data-order', index);
      });
      resolve();
    });
  }

  public render() {
    this.updateOrderAttr().then(() => {
      tinysort('[data-mods-installed] .mod',{data:'order'});
      this.mods.forEach((mod: Mod) => {
        mod.ui.renderReorder();
        mod.setEvents();
      })
    });
  }

  private getActivatedModsFormData() : FormData|null {
    let order = this.mods.map((item: Mod) => {
      if (item.ui.installed === true && item.ui.active === true) {
        return item.ui.getData().modid;
      }
    }).filter((value) => value !== undefined);

    if(!order.length) {
      return null;
    }

    const bodyFormData = new FormData();
    order.map((item: string, index) => {
      bodyFormData.append('mods[' + index + ']', item.toString());
    });

    return bodyFormData;
  }

  private postReorder() {
    this.loader.enable();

    const formData : FormData = this.getActivatedModsFormData();

    if(formData !== null) {
      Axios.post(window.updateModsOrderUrl, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        this.loader.disable();
        new Notification('success', 'Well done', response.data.message);
        window.location.reload();
      }).catch((response) => {
        this.loader.disable();
        let message = 'Something went wrong';
        if (typeof response.data !== 'undefined' && response.data.message) {
          message = response.data.message;
        }
        new Notification('danger', 'Ooops!', message);
      })
    }
  }
}

export function initMod() {
  const instances: ModUI[] = createModUIInstances();
  if (instances.length === 0) {
    return;
  }

  //arma special case$
  if ($('.mod').first().find('.mod__install-type').length > 0 || typeof window.activatedModUrl === 'undefined') {
    const mods: string[] = [];

    $('.mod').each((index, el) => {
      const data: IModData = $(el).data('mod');
      if (data.active) {
        mods.push(data.modid);
      }
    });

    const ModReorderInstance = new ModReorder(mods);
    ModReorderInstance.mods = instances.map((ui: ModUI, index) => {
      return new Mod(ui, mods, index);
    });
    ModReorderInstance.initialReorder();

  } else if (typeof window.activatedModUrl !== 'undefined') {
    Axios.get(window.activatedModUrl, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      const ModReorderInstance = new ModReorder(response.data.mods);
      ModReorderInstance.mods = instances.map((ui: ModUI, index) => {
        return new Mod(ui, response.data.mods, index);
      });

      ModReorderInstance.initialReorder();
      if (response.data.maps !== undefined && response.data.maps.length > 0) {
        instances.map((mod: ModUI) => {
          const data: IModData = mod.$base.data('mod');
          if (response.data.maps.indexOf(data.modid) > -1) {
              mod.$base.find('[data-activate]').html('Select the map in the basic settings');
            mod.$base.find('[data-uninstall]').removeAttr('disabled');
            mod.hideReorderArrows();
          }
        });
      }

      if (response.data.totalConversions !== undefined && response.data.totalConversions.length > 0) {
        instances.map((mod: ModUI) => {
          const data: IModData = mod.$base.data('mod');
          if (response.data.totalConversions.indexOf(data.modid) > -1) {
              mod.$base.find('[data-activate]').html('Select the total conversion in the basic settings');
            mod.$base.find('[data-uninstall]').removeAttr('disabled');
            mod.hideReorderArrows();
          }
        });
      }
    });
  }

  if (instances.length > 0) {
    ModUI.setCallbackOnActivateAll(Mod.activateAll.bind(this));
    ModUI.setCallbackOnDeactivateAll(Mod.deactivateAll.bind(this));
  }
}
